import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Image, Container, Nav, Navbar as BSNavbar } from 'react-bootstrap';
import { FaSun, FaMoon } from 'react-icons/fa';
import { useTheme } from "../ThemeContext";
import { isAuthenticated, removeToken } from '../services/authService';
import 'bootstrap/dist/css/bootstrap.min.css';

const Navbar = () => {
    const navigate = useNavigate();
    const { isDarkMode, setIsDarkMode } = useTheme();

    const handleLogout = () => {
        removeToken();
        navigate('/');
    };

    return (
        <BSNavbar
            expand="lg"
            fixed="top"
            className={`shadow-sm ${isDarkMode ? 'navbar-dark bg-dark' : 'navbar-light bg-white'}`}
        >
            <Container>
                <BSNavbar.Brand as="a"
    href="https://pipsqueaknetscan.com/" className="d-flex align-items-center">
                    <Image
                        src="images/logo_nb.png"
                        alt="Pipsqueak Logo"
                        width="32"
                        height="32"
                        className="me-2"
                        rounded
                    />
                    <span className="fw-bold fs-5">Pipsqueak</span>
                </BSNavbar.Brand>

                <BSNavbar.Toggle aria-controls="navbar-content" />

                <BSNavbar.Collapse id="navbar-content" className="justify-content-end">
                    <Nav className="align-items-center">
                        {/* Dark/Light Mode Toggle */}
                        <Button
                            variant={isDarkMode ? 'outline-light' : 'outline-dark'}
                            onClick={() => setIsDarkMode(prev => !prev)}
                            className="me-2"
                            aria-label="Toggle dark mode"
                        >
                            {isDarkMode ? <FaSun /> : <FaMoon />}
                        </Button>


                    </Nav>
                </BSNavbar.Collapse>
            </Container>
        </BSNavbar>
    );
};

export default Navbar;
